module.exports = __webpack_public_path__ + "static/media/checkbox_unchecked.807d4966.svg";